<template>
  <!-- 篮球数据中心 -->
  <div class="sub-page">
    <div class="data-center">
      <div class="rank-tab">
        <div class="tab-list">
          <div class="tab-item" v-for="(item, index) in dataList" :key="index" @click="handleTab(item, index)">
            <div>{{ item.name }}</div>
            <div class="line" v-show="dataIndex == index"></div>
          </div>
        </div>
        <!-- <div class="select">
          <a-select class="select-item" @change="handleSeason" placeholder="选择赛季" size="large">
            <a-select-option value="jack">
              Jack
            </a-select-option>
            <a-select-option value="lucy">
              Lucy
            </a-select-option>
          </a-select>
          <a-select class="select-item" @change="handleSeason" placeholder="选择均场" size="large">
            <a-select-option value="jack">
              Jack
            </a-select-option>
            <a-select-option value="lucy">
              Lucy
            </a-select-option>
          </a-select>
          <a-select class="select-item" @change="handleSeason" placeholder="选择球队" size="large">
            <a-select-option value="jack">
              Jack
            </a-select-option>
            <a-select-option value="lucy">
              Lucy
            </a-select-option>
          </a-select>
          <a-select class="select-item" @change="handleSeason" placeholder="选择球员" size="large">
            <a-select-option value="jack">
              Jack
            </a-select-option>
            <a-select-option value="lucy">
              Lucy
            </a-select-option>
          </a-select>
          <div>
            <a-select class="select-item" @change="handleSeason" placeholder="场次" size="large">
            <a-select-option value="jack">
              Jack
            </a-select-option>
            <a-select-option value="lucy">
              Lucy
            </a-select-option>
          </a-select>
          ~
          <a-select class="select-item" @change="handleSeason" placeholder="场次" size="large">
            <a-select-option value="jack">
              Jack
            </a-select-option>
            <a-select-option value="lucy">
              Lucy
            </a-select-option>
          </a-select>
          </div>
         
        </div> -->
        <div class="row row-title">
          <div class="col-1">排名</div>
          <div class="col-2">球队</div>
          <div class="col-3">球员</div>
          <div class="col-4">场次</div>
          <div class="col-5">分钟</div>
          <div class="col-6">得分</div>
          <div class="col-7">效率值</div>
          <div class="col-8">
            <div>投篮</div>
            <div>出手</div>
          </div>
          <div class="col-9">
            <div>投篮</div>
            <div>命中</div>
          </div>
          <div class="col-10">
            <div>投篮</div>
            <div>命中率</div>
          </div>
          <div class="col-11">
            <div>3分</div>
            <div>出手</div>
          </div>
          <div class="col-12">
            <div>3分</div>
            <div>命中</div>
          </div>
          <div class="col-13">
            <div>3分</div>
            <div>命中率</div>
          </div>
          <div class="col-14">
            <div>罚球</div>
            <div>出手</div>
          </div>
          <div class="col-14">
            <div>罚球</div>
            <div>命中</div>
          </div>
          <div class="col-14">
            <div>罚球</div>
            <div>命中率</div>
          </div>
        </div>
        <template v-if="rowList.length > 0">
          <div
            class="row"
            v-for="(item, index) in rowList"
            :key="index"
            :class="index % 2 == 1 ? 'active-bg' : ''"
            @click="paylerDetail"
          >
            <div class="col-1">{{ index + 1 }}</div>
            <div class="col-2">{{ item.name }}</div>
            <div class="col-3">胜</div>
            <div class="col-4">负</div>
            <div class="col-5">胜场差</div>
            <div class="col-6">胜率(%)</div>
            <div class="col-7">积分</div>
            <div class="col-8">返10场</div>
            <div class="col-9">连胜/败</div>
            <div class="col-10">场均得分</div>
            <div class="col-11">场均失分</div>
            <div class="col-12">净胜分</div>
            <div class="col-13">主场</div>
            <div class="col-14">客场</div>
          </div>
        </template>
        <div class="my-empty" v-else>
          <a-empty />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasketballDateCenter',
  props: {},
  data() {
    return {
      dataIndex: 0,
      dataList: [
        {
          name: '球员基础数据',
        },
        {
          name: '球员比赛统计',
        },
        {
          name: '球员高阶数据',
        },
        {
          name: '球队基础数据',
        },
        {
          name: '球队比赛统计',
        },
        {
          name: '球队高阶数据',
        },
      ],
      rowList: [],
    }
  },
  components: {},
  mounted() {},
  methods: {
    handleTab(item, index) {
      this.dataIndex = index
    },
    //选择赛季
    handleSeason(e) {
      console.log('handleSeason', e)
    },
    paylerDetail() {
      this.$router.push({ name: 'BasketallPlayer' })
    },
  },
  watch: {},
}
</script>

<style scoped lang="scss">
.sub-page {
  width: 100%;
  background-color: #f7f7f7;
  padding-top: 20px;
  padding-bottom: 30px;
  .data-center {
    width: 1200px;
    margin: 0 auto;
    .tab-list {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      margin-bottom: 10px;
      .tab-item {
        margin-right: 20px;
        font-size: 16px;
        font-weight: bold;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        cursor: pointer;
        .line {
          width: 100%;
          height: 4px;
          background-color: #aa1f23;
          margin-top: 8px;
        }
      }
    }
    .select {
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;
      .select-item {
        width: 140px;
        margin-right: 10px;
      }
    }
    .row {
      display: flex;
      justify-content: space-between;
      height: 60px;
      align-items: center;
      padding: 0 30px;
      text-align: center;
      .col-1 {
        width: 5%;
      }
      .col-2 {
        width: 10%;
      }
      .col-3 {
        width: 10%;
      }
      .col-4 {
        width: 5%;
      }
      .col-5 {
        width: 5%;
      }
    }
    .active-bg {
      background-color: #e9e9e9;
    }
    .row-title {
      background-color: #000000;
      color: #fff;
    }
    .my-empty {
      min-height: 400px;
      padding-top: 100px;
      display: flex;
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/match/basketball/components/BasketballDateCenter.vue